module.exports = __webpack_public_path__ + "static/media/CSPORT STATIC ELIMINATOR AND DEMAG IME1.b7364d7f.png";